import script from "./NoNestedTasksRow.vue?vue&type=script&setup=true&lang=js"
export * from "./NoNestedTasksRow.vue?vue&type=script&setup=true&lang=js"

import "./NoNestedTasksRow.vue?vue&type=style&index=0&id=023730b1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-023730b1"]])

export default __exports__